window.swal = require('sweetalert');
require('./plugins/text-select');

// Bootstrap
require('bootstrap/js/transition');
require('bootstrap/js/alert');
require('bootstrap/js/button');
// require('bootstrap/js/carousel');
require('bootstrap/js/collapse');
require('bootstrap/js/dropdown');
// require('bootstrap/js/modal');
require('bootstrap/js/tooltip');
require('bootstrap/js/popover');
// require('bootstrap/js/scrollspy');
// require('bootstrap/js/tab');
// require('bootstrap/js/affix');

// Browser Update
// Remind users to update their browser in an unobtrusive way
// http://browser-update.org
var browserUpdate = require('browser-update');
browserUpdate({
    required: {        // MINIMUM SUPPORTED BROWSER VERSIONS
        e:-4,          // Edge
        f:-6,          // Firefox
        i: 11,         // Internet Explorer
        o:-6,          // Opera
        s:-2,          // Safari
        c:-6           // Chrome
    },
    insecure: true,    // Show severe security issue warnings
    unsupported :true  // Show no longer supported by vendor warnings
});

(function(window, $) {

    $(function () {

        /**
         * Handle the site being embedded in an iframe
         */

        // Remove white label styles if not in an iframe
        try {
            if (window.self === window.top) {
                document.body.className = document.body.className.replace('white-label', '');
            }
        } catch (e) {
            document.body.className = document.body.className.replace('white-label', '');
        }

        // Listen for messages from parent window
        window.addEventListener('message', function(e) {

            // Load custom stylesheet from parent frame
            if(typeof e.data.srcCss !== 'undefined') {
                $('head').append('<link rel="stylesheet" href="'+e.data.srcCss+'" type="text/css" />');
                //fire an ok event after a small delay
                setTimeout(function() {
                    e.source.postMessage({ srcCssOk: 1 }, e.origin);
                }, 200);
            }

            // Open donate links in a new window if parent frame does not use HTTPS
            if(e.data == 'http:'){
                $('a.donate').attr('target', '_blank');
            }

            if(typeof e.data.initFrame !== 'undefined') {

                // Send updated page height back to parent frame
                setInterval(function() {
                    window.parent.postMessage({
                        setIframeHeight: document.body.offsetHeight
                    }, '*');
                }, 1000);

                // Send location.hash back to parent frame
                if(e.data.followHashFrags) {
                    $('a.frameHashOk').click(function(event) {
                        event.preventDefault();
                        window.parent.postMessage( {
                            framehash: $(this).attr('href')
                        } , '*');
                    });
                }
            }

        }, false);

        // Tell the parent window that we are loaded and listening
        window.parent.postMessage('ready', '*');
        window.parent.postMessage({
            setIframeHeight: document.body.offsetHeight
        }, '*');

        // Tell parent window when navigation occurs w/in iframe
        if (window.self !== window.top) {
            window.onunload = function() {
                window.parent.postMessage({
                    iframeNavigation: '*',
                    setIframeHeight: document.body.offsetHeight
                }, '*');
            }
        }


        /**
         * User interface tweaks
         */

        // Handle disabled controls
        $('.disabled').bind('click', function(e) {
            e.preventDefault();
        });

        // Show/hide the drop shadow on the header when scrolling
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll > 64) {
                $('.site-header').removeClass('noscroll').addClass('scroll');
            } else {
                $('.site-header').addClass('noscroll').removeClass('scroll');
            }
        });

        // Keep the footer at the bottom of the page, regardless of how short the page content is
        var keepFooterAtBottom = function() {
            $('.wrapper').css({
                minHeight: $(window).height() - $('.site-footer').height()
            });
        };

        $(window).resize(keepFooterAtBottom);

        keepFooterAtBottom();


        /**
         * Header search form
         * The form is initially hidden, but clicking on the magnifying glass or typing when no field has the focus
         * will show the search field and start the typing there
         */
        $('.search-input')
            .focus(function(e) {
                $(e.target).addClass('open');
            })
            .blur(function(e) {
                var $this = $(e.target);
                if ($this.val().length < 1) {
                    $this.removeClass('open');
                }
            });

        $('.search-button').click(function(e) {
            if ($('.search-input').val().length === 0) {
                e.preventDefault();
                $('.search-input').focus();
            }
        });

        $(document).keypress(function(e) {
            if (
                !$(document.activeElement).is(":input,[contenteditable]") &&
                !e.metaKey &&
                !e.ctrlKey
            ) {
                $('.search-input').focus();
            }
        });


        /**
         * Avatar / User Box
         * Clicking the avatar toggles the visiblility of the user box
         * While the user box is visible, a click anywhere else on the screen will dismiss it
         */
        var showUserBox = function() {
            $('.avatar > a').addClass('active');
            $('.user-box').fadeIn(200);

            $(document).on('click.userBox', hideUserBox);
        };

        var hideUserBox = function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            $('.avatar > a').removeClass('active');
            $('.user-box').fadeOut(300);

            $(document).off('click.userBox');
        };

        $('.avatar > a').click(function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if ($('.user-box').css('display') == 'none') {
                showUserBox();
            } else {
                hideUserBox(e);
            }
        });

        $('.user-box, .user-box a').on('click', function(e) {
            e.stopPropagation();
        });


        /**
         * Star campaign buttons
         */
        $('.star-button').click(function(e) {
            e.preventDefault();

            var $button = $(e.target);
            var action = $button.hasClass('has-star') ? 'remove' : 'add';

            var toggleStarred = function() {
                if ($button.hasClass('has-star')) {
                    $button
                        .text('Star this Campaign')
                        .removeClass('has-star');
                } else {
                    $button
                        .text('Unstar this Campaign')
                        .addClass('has-star');
                }
            }

            // Assume it's going to work to give the user immediate feedback
            toggleStarred();

            $.ajax($button.attr('href'), {
                dataType: 'json',
                data: {
                    action: action
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    swal({
                        title: 'Oops!',
                        text: 'There was an error contacting the server. Make sure you are connected to the Internet and try again.',
                        icon: 'error'
                    });

                    // Since there was an error we toggle back to the previous state
                    toggleStarred();
                }
            });
        });


        /**
         * Accordian
         */
        $('.accordian .accordian-heading a').click(function(e) {
            e.preventDefault();

            $parent = $(this).closest('.accordian-row');
            $content = $('.accordian-content', $parent);

            if ($content.css('display') == 'none') {
                $content.slideDown();

                $('.accordian-row')
                    .not($parent)
                    .find('.accordian-content')
                    .slideUp();

                $('.icon-right-open', $parent).attr('class', 'icon-down-open');

                $('.accordian-row')
                    .not($parent)
                    .find('.icon-down-open')
                    .attr('class', 'icon-right-open');
            } else {
                $content.slideUp();
                $('.icon-down-open', $parent).attr('class', 'icon-right-open');
            }
        });


        /**
         * Text field character limits
         */
        $('input, textarea')
            .filter('[data-limit]')
            .on('input', function(e) {
                var $input = $(this);
                var limit = $input.data('limit');

                if ($input.val().length > limit) {
                    $input.val($input.val().substr(0, limit));
                }

                $('.limit-count', $input.closest('.limit-wrapper'))
                    .html($input.val().length+' of '+limit);
            })
            .wrap('<div class="limit-wrapper"></div>')
            .after('<span class="limit-count"></span>')
            .trigger('input');


        /**
         * Text Select Fields
         * Fetches suggested options from AJAX endpoint based on user input
         */
        $('.text-select').textSelect();

    });


    /**
     * Set an appropriate timezone for users who aren't logged in
     */
    window.getUserTimezone = function() {
        if (navigator.cookieEnabled) {
            var visitortime = new Date();
            var visitortimezone = "GMT " + -visitortime.getTimezoneOffset() / 60;

            $.ajax({
                type: 'GET',
                url: '/timezone',
                data: 'offset='+visitortimezone,
                success: function() {
                    location.reload();
                }
            });
        }
    };


    /**
     * Open popup windows
     */
    window.popupWindow = function(url, width, height) {
        var left = (screen.width/2)-(width/2);
        var top = (screen.height/2)-(height/2);
        var newWindow = window.open(
            url,
            'popup',
            'height='+height+', width='+width+', top='+top+', left='+left
            );

        if (newWindow === null || typeof(newWindow) === 'undefined') {
            swal({
                title: "Oops!",
                text: 'Please disable your pop-up blocker and click the link again.',
                timer: 2000,
            });
        } else {
            newWindow.focus();
        }

        return false;
    };

})(window, jQuery);
